import React from "react";
import { View, Text, Platform, ViewStyle } from "react-native";
import { formattedValue } from "@lib/utilities/Formatters";
import StyleSheet from "react-native-media-query";
import ListHeading from "./ListHeading";
import { theme } from "../../theme/theme";
import { ListItemType } from "@lib";
import { BillingConstants } from "@lib/utilities/Constants";

interface InfoListSectionProps {
  title: string;
  items: { [key: string]: ListItemType };
  headerStyle?: "primary" | "secondary";
  listType?: "primary" | "secondary";
  listStyle?: ViewStyle;
  page?: string;
}

const InfoListSection: React.FC<InfoListSectionProps> = ({
  title,
  items,
  headerStyle = "primary",
  listType = "primary",
  listStyle = {},
  page,
}) => {
  const elements =Object.keys(items)?.filter((item) => item != "isDue" && item != "cashReceived") ?? [];
  return (
    <View style={{ ...listStyle }} testID={`${page}-page-${title.toLowerCase()?.replaceAll(" ","-")}-container`}>
      <ListHeading title={title} headerStyle={headerStyle} page={page} />

      <View
        style={[
          styles.listContainer,
          listType === "primary" && styles.secondaryListContainer,
        ]}
        testID={`${page}-page-${title.toLowerCase()?.replaceAll(" ","-")}-values-list-container`}
      >
        {elements.map((element, index) => {
          const isLast = index === elements.length - 1;          
          return (
            <>
              <View key={index} testID={`${page}-page-${element.toLowerCase()}-item-row`}>
                <View
                  style={[
                    styles.listItem,
                    isLast && styles.lastItem,
                    styles.justifyContent,
                  ]}
                  testID={`${page}-page-${element.toLowerCase()}-item-container`}
                >
                  <Text
                    style={[styles.lableText]}
                    dataSet={{ media: ids.lableText }}
                    testID={`${page}-page-${element.toLowerCase()}-key`}
                  >
                    {items[element]?.displayText || element}
                  </Text>
                  <Text
                    style={styles.descText}
                    dataSet={{ media: ids.descText }}
                    numberOfLines={items[element]?.displayText==BillingConstants.paymentDue?3:undefined}
                    testID={`${page}-page-${element.toLowerCase()}-value`}
                  >
                    {formattedValue(items[element])}
                  </Text>
                </View>

                {!isLast &&
                  (Platform.OS === "web" ? (
                    <View style={styles.listDottedWebBorder} />
                  ) : (
                    <View style={styles.divider} />
                  ))}
              </View>
            </>
          );
        })}
      </View>
    </View>
  );
};

const { styles, ids } = StyleSheet.create({
  divider: {
    width: "100%",
    height: 1,
    borderRadius: 50,
    backgroundColor: theme.colors.black + 35,
  },
  listContainer: {
    backgroundColor: theme.colors.white,
    width: "100%",
  },
  secondaryListContainer: {
    borderRadius: 10,
  },
  listItem: {
    backgroundColor: theme.colors.white,
    paddingHorizontal: 20,
    paddingVertical: 8,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  lastItem: {
    paddingBottom: 16,
    borderBottomEndRadius: 10,
    borderBottomLeftRadius: 10,
  },

  lableText: {
    fontSize: theme.fontsize.cs as any,
    color: theme.colors.text.secondary as any,
    fontFamily: theme.fontFamily.robotoRegular as any,
    flex:1,
    ...Platform.select({
      web: {
        fontWeight: theme.fontweight.light as any,
      },
    }),
  },
  descText: {
    textAlign: "right",
    maxWidth:"50%",
    fontSize: theme.fontsize.cs as any,
    color: theme.colors.text.primary as any,
    fontFamily: theme.fontFamily.robotoMedium as any,
    ...Platform.select({
      web: {
        fontWeight: theme.fontweight.regular as any,
      },
    }),
  },
  listDottedWebBorder: {
    height: 0,
    borderBottomWidth: 1,
    borderColor: theme.colors.text.secondary + "60",
  },
  justifyContent: {
    justifyContent: "space-between",
  },
});

export default InfoListSection;
